import React, { useState } from 'react'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { IRequestedItem, ItemsRequestModel } from '.';
import { useDispatch } from 'react-redux';
import SelectRequestedItems from './SelectRequestedItems2';
import { Skeleton } from '@mui/material';
import RequestedMissingItems from './RequestedMissingItems';
import ReturnedRequestedItems from './ReturnedRequestedItems';

interface IProps {
    items: IRequestedItem[],
    loadingItems: boolean,
    setItems: (items: IRequestedItem[]) => void,
    viewRequestPage?: boolean,
    request?: ItemsRequestModel | null,
    forceRefreshRequest: (status: boolean) => void,
    hideAllocations?: boolean,
    hideContainedItems?: boolean,
    renderAfterTabs?: () => JSX.Element
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}


export default function RequestedItemsList(props: IProps) {

    const dispatch = useDispatch()

    const {
        items,
        viewRequestPage,
        request,
        loadingItems,
        setItems,
        forceRefreshRequest,
        hideAllocations,
        hideContainedItems,
        renderAfterTabs,
    } = props

    const [tabId, setTabId] = useState<number>(0)

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabId(newValue)
    }

    const a11yProps = (index: number) => {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const CustomTabPanel = (props: TabPanelProps) => {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {/* {value === index && <Box sx={{ p: 3 }}>{children}</Box>} */}
                {value === index && <div className="tabpanel-content">{children}</div>}
            </div>
        );
    }

    /**
     * Items count
     */
    interface ItemsCountInterface {
        requested: number,
        missing: number,
        damaged: number,
        rejected: number,
        returned: number,
    }

    const itemsCount: ItemsCountInterface = {
        requested: items.length,
        missing: items.filter(item => (item.missing ?? 0)).length,
        damaged: items.filter(item => (item.damaged ?? 0)).length,
        rejected: items.filter(item => item.is_rejected === true).length,
        returned: items.filter(item => item.is_returned === true).length
    }

    return(
        <div className="single-request-requested-items-list-container">
            <div className="content-of-single-request-requested-items-list-container">

                <div className="tabs-of-single-request-requested-items-list-container">
                    <Tabs value={tabId} onChange={handleTabChange} aria-label="basic tabs example">
                        <Tab label={`Requested Items (${items.length})`} {...a11yProps(0)} />
                        {/* <Tab disabled={itemsCount.rejected > 0 ? false : true} label={`Rejected Items (${itemsCount.rejected})`} {...a11yProps(1)} /> */}
                        <Tab disabled={itemsCount.returned > 0 ? false : true} label={`Returned Items (${itemsCount.returned})`} {...a11yProps(1)} />
                        <Tab disabled={itemsCount.missing > 0 ? false : true} label={`Missing Items (${itemsCount.missing})`} {...a11yProps(2)} />
                        <Tab disabled={itemsCount.damaged > 0 ? false : true} label={`Damaged Items (${itemsCount.damaged})`} {...a11yProps(3)} />
                    </Tabs>
                </div>


                <div className="list-of-single-request-requested-items-list-container">
                    <CustomTabPanel value={tabId} index={0}>
                        {renderAfterTabs && renderAfterTabs()}
                        {loadingItems ? (
                            <>
                                <Skeleton variant="rectangular" width={"100%"} height={100} style={{ marginBottom: 10 }}/>
                                <Skeleton variant="rectangular" width={"100%"} height={100} style={{ marginBottom: 10 }}/>
                                <Skeleton variant="rectangular" width={"100%"} height={100} style={{ marginBottom: 10 }}/>
                                <Skeleton variant="rectangular" width={"100%"} height={100} style={{ marginBottom: 10 }}/>
                                <Skeleton variant="rectangular" width={"100%"} height={100} style={{ marginBottom: 10 }}/>
                                <Skeleton variant="rectangular" width={"100%"} height={100} style={{ marginBottom: 10 }}/>
                            </>
                        ):  <SelectRequestedItems hideAllocations={hideAllocations} hideContainedItems={hideContainedItems} forceRefreshRequest={(status) => forceRefreshRequest(status)} request={request} items={items} setItems={(items) => setItems(items)}  viewRequestPage={true} />}
                    </CustomTabPanel>

                    {/* <CustomTabPanel value={tabId} index={1}>
                        {request && <RequestedMissingItems request={request} items={items} loadingItems={loadingItems} showRejected hideTitle />}
                    </CustomTabPanel> */}

                    <CustomTabPanel value={tabId} index={1}>
                        {request && <ReturnedRequestedItems request={request} items={items} loadingItems={loadingItems} hideTitle />}
                    </CustomTabPanel>

                    <CustomTabPanel value={tabId} index={2}>
                        {request && <RequestedMissingItems request={request} items={items} loadingItems={loadingItems} hideTitle />}
                    </CustomTabPanel>

                    <CustomTabPanel value={tabId} index={3}>
                        {request && <RequestedMissingItems request={request} items={items} loadingItems={loadingItems} showDamaged hideTitle />}
                    </CustomTabPanel>

                </div>

            </div>
        </div>
    )
}